export default function PageLoader() {
  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center">
      <div className="font-display uppercase tracking-[0.4em] text-white/40 text-sm animate-pulse">
        Loading
      </div>
    </div>
  );
}
